import { InstagramEmbed } from "react-social-media-embed";

const InstagramEmbedd = ({ url }) => {
  return (
      <InstagramEmbed
        url={url}
        linkText="Loading..."
        height={464}
        width={328}
        // placeholderSpinnerDisabled
      />
  );
};

export default InstagramEmbedd;
